import assignIndex from './assignIndex'
import { calcHeight, calcWidth } from './dimensions'
import fillDimensions from './fillDimensions'
import filterPhotos from './filterPhotos'
import findMaxOrMinFrame from './findMaxOrMinFrame'
import matchFrameToResize from './matchFrameToResize'
import perMeterCalc from './perMeterCalc'
import shouldRender from './shouldRender'
import slugFromUrl from './slugFromUrl'
import calcCenter from './calcCenter'

export {
  assignIndex,
  filterPhotos,
  perMeterCalc,
  calcWidth,
  calcHeight,
  shouldRender,
  matchFrameToResize,
  findMaxOrMinFrame,
  fillDimensions,
  slugFromUrl,
  calcCenter,
}



// WEBPACK FOOTER //
// ./src/utils/index.js